<template>
  <div class="long-term-wrapper">
    <p v-show="smallScreen">Your device is too narrow to display this graphic. Please visit this page from a larger device or <router-link to='/'>go to the Compare Quarters view</router-link>.</p>
    <map-controls
      v-show="!smallScreen" 
      :grayscale="grayscale" 
      :toggleScale="toggleScale"
      :state="state"
      :riskData="timeBlock"></map-controls>
    <map-container
      v-show="!smallScreen"
      :timeBlock="timeBlock"
      :state="state">
    </map-container>
  </div>
</template>

<script>
import MapControls from '../map-controls/MapControls';
import HeatMapContainer from '../heat-map-container/HeatMapContainer';
import beforeRouteLeave from '../../helpers/navHelpers';

export default {
  name: 'long-term-map',
  props: ['riskData', 'state', 'grayscale', 'toggleScale', 'timeBlock', 'setLoading', 'smallScreen'],
  components: {
    'map-controls': MapControls,
    'map-container': HeatMapContainer,
  },
  data() {
    return {
      downloadLink: process.env.DOWNLOAD_URL,
    };
  },
  mounted() {
    this.setLoading(false);
  },
  beforeRouteLeave,
};
</script>

<style>
  .long-term-wrapper {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// LongTermMap.vue?6980ac7c